import { useState } from "react";

import { Button } from "@features/ui";

import RestockAllocationSelectionModal from "./restockModal";

const RestockOrdersButton = (props: { disabled: boolean }) => {
  const [restockModalOpen, setRestockModalOpen] = useState(false);
  return (
    <>
      {restockModalOpen && (
        <RestockAllocationSelectionModal
          onClose={() => setRestockModalOpen(false)}
        />
      )}
      <Button
        fullWidth
        variant="contained"
        color="secondary"
        onClick={() => setRestockModalOpen(true)}
        {...props}
        className="whitespace-nowrap"
      >
        Re-stock Orders
      </Button>
    </>
  );
};
export default RestockOrdersButton;
